export default __webpack_public_path__ + "static/media/icon_chevron_hub_right_mobile.b8e94215.svg";